module.exports = __webpack_public_path__ + "img/PennyInBergen.3c77cb4b.jpg";